<template>
  <div class="content-download-overview">
    <FilterControl v-model="selectedCategory" :items="sortedCategories" :title="data.title" />

    <div v-for="downloadCategory in filteredCategories" :key="downloadCategory.id" class="detail-container">
      <h3 v-if="downloadCategory.category" class="downloadcategory">{{ downloadCategory.category }}</h3>
      <div
        v-for="downloadFiles in downloadCategory._allReferencingDownloads"
        :key="downloadFiles.id"
        class="downloadfiles"
      >
        <a
          :key="downloadFiles.id"
          :href="downloadFiles.document?.url"
          target="_blank"
          class="document lead"
          :download="downloadFiles.documentTitle"
        >
          {{ downloadFiles.documentTitle }}
          <SvgDownload />
        </a>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { type ContentDownloadOverviewFragment } from '#gql/default';
import FilterControl from '~/components/content-modules/components/FilterControl.vue';
import SvgDownload from '~/components/content-modules/svgs/SvgDownload.vue';

const props = defineProps<{
  data: ContentDownloadOverviewFragment;
}>();

const selectedCategory = ref<{ id: string; name: string }>();

const sortedCategories = computed(function () {
  return props.data.downloadCategories.map((category) => ({
    id: category.id,
    name: category.category ?? '',
  }));
});

const filteredCategories = computed(function () {
  return props.data.downloadCategories.filter(
    (category) => !selectedCategory.value || category.id === selectedCategory.value.id,
  );
});
</script>

<style scoped lang="scss">
.content-download-overview {
  @include grid-layout();

  & {
    padding: var(--site-inner-padding);
    width: 100%;
    max-width: var(--site-max-width);
  }

  > .detail-container {
    display: grid;
    width: 100%;
    padding: var(--spacing-sm) 0;

    @media (--xs) {
      grid-column: 1 / -1;
    }

    @media (--sm) {
      grid-column: 2 / 24;
    }

    @media (--md), (--lg) {
      grid-column: 5 / 21;
    }

    > .downloadcategory {
      color: var(--color-forest-dark);

      @media (--xs), (--sm) {
        margin-bottom: var(--spacing-2xs);
      }

      @media (--md), (--lg) {
        margin-bottom: var(--spacing-xs);
      }
    }

    > .downloadfiles {
      &:first-of-type {
        border-top: 1px solid var(--color-forest-dark);
      }

      > .document {
        color: var(--color-forest-dark);
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid var(--color-forest-dark);
        padding: var(--spacing-3xs) 0;
        gap: var(--spacing-3xs);

        > .icon {
          fill: var(--color-forest-dark);
        }
      }
    }
  }
}
</style>
